import React from 'react';
import Navigation from '../components/Navigation';
import HeroSection from '../components/HeroSection';
import CoreFeatures from '../components/CoreFeatures';
import AIIntegrationHub from '../components/AIIntegrationHub';
import ApplicationsSection from '../components/ApplicationsSection';
import StatisticsSection from '../components/StatisticsSection';
import TeamSection from '../components/TeamSection';
import PricingSection from '../components/PricingSection';
import TestimonialsSection from '../components/TestimonialsSection';
import ContactFooter from '../components/ContactFooter';
import PartnersSection from '@/components/PartnersSection';
import QASection from '@/components/QASection';

const HomePage: React.FC = () => {
  return (
    <div className="min-h-screen bg-slate-900 text-white">
      <Navigation />
      
      <HeroSection />
      
      <AIIntegrationHub />
      
      <CoreFeatures />
      
      <ApplicationsSection />
      
      <StatisticsSection />
      
      <TeamSection />

      <PartnersSection />

      <PricingSection />
      
      <TestimonialsSection />

      <QASection />
      
      <ContactFooter />
    </div>
  );
};

export default HomePage;
